(function(angular){
	'use strict';
	
	var toastObject = {
		bindings: {
			index: '<',
			message: '<',
			type: '<'
		},
		controller: [
			'$q',
			'$timeout',
			ToastFunction
		],
		controllerAs: 'toast',
		require: {
			parent: '^toastContainer'
		},
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		]
	};
	
	angular
		.module('toastModule')
		.component('toast', toastObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/toast/toast.html';
	}
	
	function ToastFunction(
		$q,
		$timeout
	){
		var toast = this;
		var dismissalTimer;

		toast.active = false;

		toast.clearDismissalTimer = function() {
			$timeout.cancel(dismissalTimer);
		};

		toast.dismiss = function() {
			toast.dismissed = true;
			$timeout(function() {
				toast.remove();
			}, 500);
		};

		toast.remove = function() {
			toast.parent.remove(toast.index);
		};

		toast.setDismissalTimer = function(duration) {
			dismissalTimer = $timeout(function() {
				toast.dismiss();
			}, duration);
		};

		toast.show = function() {
			var shown = $q.defer();

			$timeout(function() {
				toast.active = true;
				shown.resolve();
			}, 10);

			return shown.promise;
		};

		toast.$onInit = function() {
			if(angular.isDefined(toast.type)) {
				toast.iconType = 'alert-' + toast.type + '-32x32';
			}

			toast.show().then(function() {
				toast.setDismissalTimer(3000);
			});
		};
	}
})(window.angular);